import { EvalFunc } from "../evaluation.service";

export const identityEval: EvalFunc = (bp: any) => undefined;
